import * as S from './styles'

export type TooltipProps = {
  text: string
}
export const Tooltip: React.FC<TooltipProps> = ({ text }) => (
  <S.Tooltip className="tooltip">{text}</S.Tooltip>
)
